export const titleBuilder = (title?: string): string =>
    `${title ? title + ' | ' : ''}devsbrasil.com - video tutoriais e posts sobre programação`;
